(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart-modal"] && !Shopify.designMode) return;
  try {
    class SizeChartModal {
    constructor() {
      this.modal = document.querySelector('[data-size-chart-modal]');
      this.trigger = document.querySelector('[data-size-chart-trigger]');
      this.closeButtons = document.querySelectorAll('[data-size-chart-close]');
      
      if (!this.modal || !this.trigger) return;
      
      // Move modal to body level to ensure it's above all elements
      this.moveModalToBody();
      this.init();
    }
    
    moveModalToBody() {
      // Move the modal to the end of the body to ensure it's above all other elements
      if (this.modal && document.body) {
        document.body.appendChild(this.modal);
      }
    }
    
    init() {
      this.trigger.addEventListener('click', () => this.open());
      this.closeButtons.forEach(button => {
        button.addEventListener('click', () => this.close());
      });
      
      // Close on backdrop click
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal || e.target.closest('[data-size-chart-close]')) {
          this.close();
        }
      });
      
      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
        }
      });
    }
    
    open() {
      this.modal.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
      
      // Focus management
      const closeButton = this.modal.querySelector('[data-size-chart-close]');
      if (closeButton) {
        closeButton.focus();
      }
    }
    
    close() {
      this.modal.removeAttribute('data-open');
      document.body.style.overflow = '';
      
      // Return focus to trigger
      if (this.trigger) {
        this.trigger.focus();
      }
    }
    
    isOpen() {
      return this.modal.hasAttribute('data-open');
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new SizeChartModal());
  } else {
    new SizeChartModal();
  }
  } catch(e) { console.error(e); }
})();

})();
